import { Dispatch, SetStateAction, useState } from "react";
import { UseQueryResult, useQuery } from "react-query";
import { Device, useQueryApiError } from "../types";
import { getDevicesByCiamIdService } from "../services/getDevicesByCiamIdService";

type UseDeviceByCiamIdParams = {
  serviceProvider: string;
  token: string;
  ciamId: string;
  username: string;
};

type UseDeviceByCiamIdHookType = {
  devicesByCiamIdQuery: UseQueryResult<Device[], useQueryApiError>;
  setFetched: Dispatch<SetStateAction<boolean>>;
};

export const useDeviceByCiamId = ({
  serviceProvider,
  token,
  ciamId,
  username
}: UseDeviceByCiamIdParams): UseDeviceByCiamIdHookType => {
  const [fetched, setFetched] = useState(false);

  const keyCache = `${serviceProvider}-${ciamId}-${username}-device`;

  const devicesByCiamIdQuery = useQuery<any, useQueryApiError>(
    [keyCache],
    async () => {
      const response = await getDevicesByCiamIdService({ serviceProvider, token, ciamId, username });

      setFetched(false);
      return response;
    },
    { enabled: fetched, cacheTime: 500 }
  );

  return {
    devicesByCiamIdQuery,
    setFetched
  };
};
